import {ReachAssetSource} from "../../apis/requests/assets/types";
import {ChipVariant} from "../templates/templateDisplay";

export const ASSET_SOURCE_DISPLAY: Record<ReachAssetSource, {label: string; variant: ChipVariant}> = {
  manual: {label: "Uploaded", variant: "inherit"},
  imported: {label: "Imported", variant: "pink"},
  customer_io: {label: "Customer.io", variant: "yellow"},
};

export const formatAssetSize = (sizeBytes: number): string => {
  if (sizeBytes < 1024) return `${sizeBytes} B`;
  if (sizeBytes < 1024 * 1024) return `${Math.round(sizeBytes / 1024)} KB`;
  return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`;
};
